var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.434,
    height: 30.2,
    viewBox: "0 0 26.434 30.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "approvals-app-svgrepo-com",
    transform: "translate(-3.4 -1.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28945",
    "data-name": "Path 28945",
    d: "M14.491,2.366a1.25,1.25,0,0,1,1.768,0l3.756,3.753a1.25,1.25,0,0,1,0,1.769l-3.756,3.747a1.25,1.25,0,0,1-1.766-1.77l1.606-1.6A10.625,10.625,0,1,0,27.235,19.439a1.25,1.25,0,0,1,2.5.13A13.125,13.125,0,1,1,16.118,5.76L14.492,4.134A1.25,1.25,0,0,1,14.491,2.366Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28946",
    "data-name": "Path 28946",
    d: "M20.384,12.366a1.25,1.25,0,0,1,0,1.768l-6.25,6.25a1.25,1.25,0,0,1-1.768,0l-2.5-2.5a1.25,1.25,0,0,1,1.768-1.768l1.616,1.616,5.366-5.366A1.25,1.25,0,0,1,20.384,12.366Z",
    transform: "translate(1.5 2.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.6dcacaf321f8a1ef1555d374cbaaf86f.svg";
export { ForwardRef as ReactComponent };